/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_EmptyInputs */

const vi_expense_sync_empty = /** @type {(inputs: Expense_Sync_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có giao dịch nào chờ duyệt`)
};

/**

* @param {Expense_Sync_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_empty = /** @type {((inputs?: Expense_Sync_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_empty(inputs)
});